export default "__VITE_ASSET__XeGOqHGJ__"